import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPRangeSlider, { SLPRangeSliderRef } from 'utilities/slp/rangeSlider/rangeSlider.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';

const SLPSliderQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPRangeSliderRef>(null);
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function getValue(a: any) {
        if (question.validations) {
            return question.validations.find((i) => i.title === a)?.value?.toString();
        }
    }

    function validate(e?: boolean) {
        if (question.is_required && !inputRef.current?.getValue()) {
            if (e) inputRef.current?.setError(lang.scoreErr);
            return false;
        }
        return true;
    }

    function setAnswer() {
        const value = inputRef.current?.getValue();
        const data = [...props.answerList];
        if (value && validate()) {
            const response: AnswerItem = {
                value: value.toString(),
                question: props.question,
                id: new Date().getTime(),
                answer: props.answer?.id,
            };
            index !== undefined && index > -1 ? (data[index] = response) : data?.push(response);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (value && validate(e) && props.answer)
            props.submit({
                value: value.toString(),
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
    }

    return (
        <SLPRangeSlider
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            hint={extractTitle(hint, false, false)}
            endTitle={getValue(QuestionValidationTypes.endTitle)}
            middleTitle={getValue(QuestionValidationTypes.middleTitle)}
            startTitle={getValue(QuestionValidationTypes.startTitle)}
            max={Number(question.validations?.find((i) => i.title === QuestionValidationTypes.max)?.value)}
            min={Number(question.validations?.find((i) => i.title === QuestionValidationTypes.min)?.value)}
            //color={props.SLP?.form?.answer_color}
            labelColor={props.form?.question_color}
            required={question.is_required}
            onChangeCompelete={setAnswer}
            dir={props.form.direction}
            defaultValue={
                index !== undefined && index > -1 && props.answerList[index].value
                    ? Number(props.answerList[index].value)
                    : undefined
            }
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPSliderQuestion));
